import { Layout } from "@/components/layout";
import { useAuth } from "@/contexts/auth";
import { useLocation } from "wouter";
import { useEffect } from "react";
import AdminTickets from "./admin-tickets";

export default function ModeratorTickets() {
  const { user } = useAuth();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (user && !["admin", "master_admin", "moderator"].includes(user.role)) {
      navigate("/");
    }
  }, [user, navigate]);

  if (!user || !["admin", "master_admin", "moderator"].includes(user.role)) return null;

  // Moderators and admins both use the same ticket interface
  return <AdminTickets />;
}
